import React from "react";
import { ReactSVG } from "react-svg";

const PaymentMethods = ({
  payWith,
  svg,
  title,
  setPayWith,
  isPaymentInfoDataValue,
  Active = false,
}) => {
  const canPay = isPaymentInfoDataValue && Active;

  return (
    <div
      role="button"
      tabIndex={canPay ? 0 : -1}
      className={`relative flex flex-col items-center justify-center gap-3 rounded-xl border p-5 min-h-[110px] transition-all ${
        canPay
          ? "border-[#1F2937] bg-[#0F172A] hover:border-red-600/50 hover:bg-red-600/5 cursor-pointer"
          : "border-[#1F2937] bg-[#0F172A] cursor-not-allowed opacity-70"
      }`}
      onClick={() => {
        if (!canPay) return;
        setPayWith(payWith);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" && canPay) setPayWith(payWith);
      }}
    >
      {!Active && (
        <div
          className="absolute inset-0 z-10 flex flex-col items-center justify-center rounded-xl bg-[#0F172A]/80 backdrop-blur-sm"
          aria-hidden
        >
          <p className="text-white text-xs font-black uppercase tracking-wider">
            Coming Soon
          </p>
        </div>
      )}

      <div className="[&_svg]:max-h-10 [&_svg]:w-auto">
        <ReactSVG src={svg} />
      </div>
      <p className="text-sm font-bold uppercase tracking-tight text-white/80">
        {title}
      </p>
    </div>
  );
};

export default PaymentMethods;
